/*
 * Adds product context to Bazaarvoice inline-rating link names without
 * changing the vendor-rendered text or destination. Bazaarvoice injects and
 * redraws these links asynchronously, so one document observer covers initial
 * render, widget updates, and product cards added by AJAX or section rendering.
 */
(function () {
  if (window.__bvInlineRatingA11yInit) return;
  window.__bvInlineRatingA11yInit = true;

  var SLOT_SELECTOR = '.bv-inline-rating[data-bv-product-title]';
  var LINK_SELECTOR = 'a.bv_main_container';
  var TEXT_SELECTOR = '.bv_text';

  function normalize(value) {
    return (value || '').replace(/\s+/g, ' ').trim();
  }

  function visibleLabel(link) {
    var nodes = link.querySelectorAll(TEXT_SELECTOR);
    var parts = [];

    for (var i = 0; i < nodes.length; i++) {
      var part = normalize(nodes[i].textContent);
      if (part) parts.push(part);
    }

    var spaced = normalize(parts.join(' '));
    return spaced || normalize(link.textContent);
  }

  function adapt(slot) {
    var productTitle = normalize(slot.getAttribute('data-bv-product-title'));
    var link = slot.querySelector(LINK_SELECTOR);
    if (!productTitle || !link) return;

    var visualLabel = visibleLabel(link);
    var currentLabel = normalize(link.getAttribute('aria-label'));
    if (!visualLabel || !currentLabel) return;

    if (currentLabel !== link.__bvA11yAppliedLabel) {
      link.__bvA11yVendorLabel = currentLabel;
    }

    var vendorLabel = link.__bvA11yVendorLabel;
    if (!vendorLabel) return;

    var nextLabel = normalize(vendorLabel + ' ' + visualLabel + ' ' + productTitle);
    link.__bvA11yAppliedLabel = nextLabel;
    if (currentLabel !== nextLabel) link.setAttribute('aria-label', nextLabel);
  }

  function scan(scope) {
    if (!scope || scope.nodeType !== 1) return;

    if (scope.matches && scope.matches(SLOT_SELECTOR)) adapt(scope);

    var slots = scope.querySelectorAll(SLOT_SELECTOR);
    for (var i = 0; i < slots.length; i++) adapt(slots[i]);
  }

  function closestSlot(node) {
    var element = node.nodeType === 1 ? node : node.parentElement;
    return element && element.closest ? element.closest(SLOT_SELECTOR) : null;
  }

  function observe() {
    if (window.__bvInlineRatingA11yObserver || typeof MutationObserver === 'undefined') return;

    var target = document.body || document.documentElement;
    if (!target) return;

    var observer = new MutationObserver(function (mutations) {
      var slots = [];

      function queue(slot) {
        if (slot && slots.indexOf(slot) === -1) slots.push(slot);
      }

      for (var i = 0; i < mutations.length; i++) {
        var mutation = mutations[i];
        queue(closestSlot(mutation.target));

        for (var j = 0; j < mutation.addedNodes.length; j++) {
          var added = mutation.addedNodes[j];
          if (added.nodeType !== 1) continue;
          queue(closestSlot(added));
          scan(added);
        }
      }

      for (i = 0; i < slots.length; i++) adapt(slots[i]);
    });

    observer.observe(target, {
      attributes: true,
      attributeFilter: ['aria-label'],
      characterData: true,
      childList: true,
      subtree: true
    });
    window.__bvInlineRatingA11yObserver = observer;
  }

  function init() {
    scan(document.documentElement);
    observe();
  }

  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
})();
